import { render, staticRenderFns } from "./TutorialsInfo.vue?vue&type=template&id=4cbb1436&scoped=true"
import script from "./TutorialsInfo.vue?vue&type=script&lang=js"
export * from "./TutorialsInfo.vue?vue&type=script&lang=js"
import style0 from "./TutorialsInfo.vue?vue&type=style&index=0&id=4cbb1436&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbb1436",
  null
  
)

export default component.exports